
  export default {
    props: {
      bikeImage: {
        type: String,
        default: '/aviator.jpg'
      },
      bikeName: {
        type: String,
        default: 'Bike Name'
      },
      noOfBikes: {
        type: Number,
        default: 0
      },
      noOfDays: {
        type: Number,
        default: 0
      },
      pickUpDate: {
        type: String,
        default: 'DD MMM'
      },
      pickUpTime: {
        type: String,
        default: 'HH:MM'
      },
      dropInDate: {
        type: String,
        default: 'DD MMM'
      },
      dropInTime: {
        type: String,
        default: 'HH:MM'
      },
      rentalPlan: {
        type: Number,
        default: 0
      },
      rentalTotal: {
        type: Number,
        default: 0
      },
      isTwoGrid: {
        type: Boolean,
        default: false
      },
      rentalTicket: {
        type: Boolean,
        default: false
      },
      location: {
        type: String,
        default: 'Vehicle Loaction'
      },
      ticketId:{
         type: String,
        default: 'ticketID'
      }
    },
    methods: {
      setFallbackImageUrl(event) {
        event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
      },
    }
  }

